module.exports = __webpack_public_path__ + "static/media/without-location.e6ec876e.png";